import { apiRequest, apiUpload } from './client';
// ============================================================================
// Permissions API
// ============================================================================
export async function getPermissions() {
    return apiRequest('GET', '/permissions');
}
// ============================================================================
// Roles API
// ============================================================================
export async function getRoles(clinicId) {
    return apiRequest('GET', `/roles?clinicId=${encodeURIComponent(clinicId)}`);
}
export async function createRole(request) {
    return apiRequest('POST', '/roles', request);
}
export async function updateRole(id, request) {
    return apiRequest('PUT', `/roles/${id}`, request);
}
export async function deleteRole(id) {
    return apiRequest('DELETE', `/roles/${id}`);
}
// ============================================================================
// Current User API
// ============================================================================
export async function getCurrentUser() {
    return apiRequest('GET', '/users/me');
}
export async function updateCurrentUser(request) {
    return apiRequest('PUT', '/users/me', request);
}
export async function changePassword(request) {
    return apiRequest('POST', '/auth/me/change-password', request);
}
export async function uploadAvatar(file) {
    const formData = new FormData();
    formData.append('file', file);
    return apiUpload('POST', '/users/me/avatar', formData);
}
export async function uploadSignature(file) {
    const formData = new FormData();
    formData.append('file', file);
    return apiUpload('POST', '/users/me/signature', formData);
}
export async function removeSignature() {
    return apiRequest('DELETE', '/users/me/signature');
}
export async function uploadClinicLogo(clinicId, file) {
    const formData = new FormData();
    formData.append('file', file);
    return apiUpload('POST', `/clinic/${clinicId}/logo`, formData);
}
export async function removeClinicLogo(clinicId) {
    return apiRequest('DELETE', `/clinic/${clinicId}/logo`);
}
export async function getUserPreferences() {
    return apiRequest('GET', '/users/me/preferences');
}
export async function putUserPreferences(preferences) {
    return apiRequest('PUT', '/users/me/preferences', preferences);
}
// ============================================================================
// Users API
// ============================================================================
export async function getUsers(query = {}) {
    const params = new URLSearchParams();
    if (query.search)
        params.set('search', query.search);
    if (query.status)
        params.set('status', query.status);
    if (query.roleId)
        params.set('roleId', query.roleId);
    if (query.page)
        params.set('page', query.page.toString());
    if (query.pageSize)
        params.set('pageSize', query.pageSize.toString());
    const queryString = params.toString();
    const endpoint = `/users${queryString ? `?${queryString}` : ''}`;
    return apiRequest('GET', endpoint);
}
export async function getUserById(id) {
    return apiRequest('GET', `/users/${id}`);
}
export async function updateUser(id, request) {
    return apiRequest('PUT', `/users/${id}`, request);
}
export async function disableUser(id, clinicId) {
    return apiRequest('POST', `/users/${id}/disable`, { clinicId });
}
export async function enableUser(id, clinicId) {
    return apiRequest('POST', `/users/${id}/enable`, { clinicId });
}
export async function resetPassword(id, clinicId) {
    return apiRequest('POST', `/auth/users/${id}/reset-password`, { clinicId });
}
export async function adminClearMfa(id, clinicId) {
    return apiRequest('DELETE', `/auth/users/${id}/mfa`, { clinicId });
}
export async function getAllClinics() {
    return apiRequest('GET', '/clinic');
}
export async function updateClinicBrandingText(clinicId, body) {
    return apiRequest('PUT', `/clinic/${clinicId}/branding-text`, body);
}
// ============================================================================
// Invitations API
// ============================================================================
export async function getInvitations(status) {
    const queryString = status ? `?status=${encodeURIComponent(status)}` : '';
    return apiRequest('GET', `/invitations${queryString}`);
}
export async function createInvitation(request) {
    return apiRequest('POST', '/invitations', request);
}
export async function resendInvitation(id) {
    return apiRequest('POST', `/invitations/${id}/resend`);
}
export async function revokeInvitation(id) {
    return apiRequest('POST', `/invitations/${id}/revoke`);
}
